import React from 'react';
import Info from '../Symbols/Info';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import Wrapper from '../Symbols/Wrapper';

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { price, years, income, payment, debt },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Hypoteční kalkulačka 2019">
				<InputCurrency
					label="Kupní cena nemovitosti"
					name="price"
					value={price}
					onChange={changeHandler('price')}
					onBlur={validateHandler('price')}
					passedProps={{ min: 1, step: 1, 'data-cy': 'price' }}
					error={errors.price}
				/>

				<Input
					label="Doba splatnosti hypotéky (roky)"
					name="years"
					value={years}
					type="number"
					onChange={changeHandler('years')}
					onBlur={validateHandler('years')}
					passedProps={{ min: 1, max: 30, step: 1, 'data-cy': 'years' }}
					error={errors.years}
				/>

				<InputCurrency
					label="Čistý měsíční příjem"
					name="income"
					value={income}
					onChange={changeHandler('income')}
					onBlur={validateHandler('income')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'income' }}
					error={errors.income}
				/>

				<InputCurrency
					label={
						<>
							Měsíční splátky dluhů <sup>1</sup>
						</>
					}
					name="payment"
					value={payment}
					onChange={changeHandler('payment')}
					onBlur={validateHandler('payment')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'payment' }}
					error={errors.payment}
				/>

				<InputCurrency
					label={
						<>
							Současný dluh celkem <sup>2</sup>
						</>
					}
					name="debt"
					value={debt}
					onChange={changeHandler('debt')}
					onBlur={validateHandler('debt')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'debt' }}
					error={errors.debt}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result hypoteka={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
				<Info css={Row}>
					<p>Kalkulačka počítá s ročním úrokem 2,5 % a fixací na 5 let.</p>

					<p>
						<sup>1</sup> Položka zahrnuje výše měsíčních splátek hypoték, úvěrů, půjček, leasingů
						atd. Banky k tomu často ještě připočítávají 5 % z kontokorentního rámce a 5 % z rámce
						kreditní karty.
					</p>

					<p>
						<sup>2</sup> Položka představuje součet všech dluhů - hypoték, úvěrů, půjček atd. a to
						včetně rámců kreditních karet a kontokorentů.
					</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
